/* istanbul ignore file */

import React from "react";
import { bedragFormatNull } from "../infra/scenario-utils";
import {
  InkomensanalyseResultaat,
  ToelichtingOptions,
} from "../../../../.generated/rapportage/rapportagetypes";
import { CitationRef } from "../citation-notes";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";

export interface MaximaleHypotheekTableProps {
  inkomensanalyseResultaten: InkomensanalyseResultaat[];
  showAll?: boolean;
}

const emptyData = {
  maxHypotheek: "",
  hypotheekSaldo: "",
  overschrijding: "",
};

export const MaximaleHypotheekTable: React.FC<MaximaleHypotheekTableProps> = ({
  inkomensanalyseResultaten,
  showAll = false,
}: MaximaleHypotheekTableProps) => {
  let data = inkomensanalyseResultaten.map((resultaat) => {
    if (
      resultaat?.maximaleHypotheekBedrag === null &&
      resultaat?.hypotheeksaldoBedrag === null
    ) {
      return emptyData;
    }
    return {
      maxHypotheek: bedragFormatNull(resultaat.maximaleHypotheekBedrag),
      hypotheekSaldo: bedragFormatNull(resultaat.hypotheeksaldoBedrag),
      overschrijding: bedragFormatNull(
        Math.abs(
          Math.min(
            (resultaat.maximaleHypotheekBedrag ?? 0) -
              (resultaat.hypotheeksaldoBedrag ?? 0),
            0,
          ),
        ),
      ),
    };
  });

  if (!showAll && data.length > 1) {
    data = data.slice(0, 1);
  }

  const columns: Column[] = [
    {
      header: "",
      accessor: () => "",
    },
    {
      header: "Maximale hypotheek",
      accessor: "maxHypotheek",
    },
    {
      header: (
        <>
          Hypotheeksaldo <CitationRef type={ToelichtingOptions.OrvUitkering} />
        </>
      ),
      accessor: "hypotheekSaldo",
    },
    {
      header: "Overschrijding van uw maximale hypotheek",
      accessor: "overschrijding",
      style: "font-weight: bold;",
      violation: (value: string) => {
        const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
        return numericValue > 0;
      },
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        data={data}
        rotate
        id="maximale-hypotheek-table"
        className="scenario__table mb-4 table table-striped table-bordered table-hover table-responsive"
        showHeader={false}
        regularStyles={data.length > 1}
      />
    </>
  );
};
